import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslatorService } from '../translator';

@Injectable({
  providedIn: 'root',
})
export class CustomMatPaginatorIntl
  extends MatPaginatorIntl
  implements OnDestroy
{
  firstPageLabel: string;
  itemsPerPageLabel: string;
  lastPageLabel: string;
  nextPageLabel: string;
  previousPageLabel: string;

  langSubscription;

  constructor(private readonly translateService: TranslatorService) {
    super();
    this.langSubscription = this.translateService.getLangChangeEvent();
    this.langSubscription.subscribe(() => {
      this.getAndInitTranslations();
    });
    this.getAndInitTranslations();
  }

  ngOnDestroy() {
    this.langSubscription.unsubscribe();
  }

  getAndInitTranslations() {
    this.translateService.getCurrentLang().subscribe((lang) => {
      this.firstPageLabel = this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.firstPageLabel'
      );
      this.itemsPerPageLabel = this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.itemsPerPageLabel'
      );
      this.lastPageLabel = this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.lastPageLabel'
      );
      this.nextPageLabel = this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.nextPageLabel'
      );
      this.previousPageLabel = this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.previousPageLabel'
      );
      this.changes.next();
    });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0) {
      return this.translateService.getInstantTranslation(
        'GlobalApplicativeConstants.customPagination.rangeLabelOnlyOne'
      );
    }
    const amountPages = Math.ceil(length / pageSize);
    return this.translateService.getInstantTranslation(
      'GlobalApplicativeConstants.customPagination.rangeLabelMulti',
      { pageNumber: page + 1, amountPages, amountItem: length }
    );
  };
}
